(() => {
  const roots = document.querySelectorAll("[data-minestone-diy]");

  if (!document.getElementById("minestone-diy-mobile-emma-spacing")) {
    const style = document.createElement("style");
    style.id = "minestone-diy-mobile-emma-spacing";
    style.textContent = `
      @media (max-width: 900px) {
        [data-minestone-diy] .minestone-diy__stage {
          min-height: 326px;
          height: clamp(326px, 46svh, 440px);
          padding: 60px 8px 8px;
        }
        [data-minestone-diy] .minestone-diy__ring-wrap {
          width: min(100%, 336px, calc(100svw - 34px), 39svh);
          max-height: 100%;
          transform: none;
        }
      }
      @media (max-width: 430px) {
        [data-minestone-diy] .minestone-diy__stage {
          min-height: 326px;
          height: min(43svh, 360px);
        }
        [data-minestone-diy] .minestone-diy__ring-wrap {
          width: min(100%, 326px, calc(100svw - 34px), 37svh);
        }
      }
    `;
    document.head.appendChild(style);
  }

  document.querySelectorAll(".tce-diy-seo__inner").forEach((inner) => {
    if (inner.dataset.disclosureReady === "true") return;

    const disclosure = document.createElement("details");
    const summary = document.createElement("summary");
    disclosure.className = "tce-diy-seo__disclosure";
    summary.textContent = "Bracelet planning guides";
    disclosure.append(summary);

    while (inner.firstChild) disclosure.append(inner.firstChild);
    inner.append(disclosure);
    inner.dataset.disclosureReady = "true";
  });

  if (!roots.length) return;

  const beadMasters = [
    { category: "Accessories", name: "天然冰种天河石7颗圆珠跑环", internalName: "天然冰种天河石7颗圆珠跑环", image: "running-ring-001.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然橙月光石", internalName: "5A天然橙月光石", image: "running-ring-002.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然粉晶", internalName: "天然粉晶", image: "running-ring-003.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然白色珍珠贝", internalName: "天然白色珍珠贝", image: "running-ring-004.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然紫水晶", internalName: "5A天然紫水晶", image: "running-ring-005.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然蓝月光石", internalName: "5A天然蓝月光石", image: "running-ring-006.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然黄水晶", internalName: "5A天然黄水晶", image: "running-ring-007.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "7A天然灰月光石", internalName: "7A天然灰月光石", image: "running-ring-008.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然葡萄石", internalName: "5A天然葡萄石", image: "running-ring-009.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "7A天然白水晶", internalName: "7A天然白水晶", image: "running-ring-010.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "7A天然茶水晶", internalName: "7A天然茶水晶", image: "running-ring-011.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "7A天然白玛瑙", internalName: "7A天然白玛瑙", image: "running-ring-012.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然紫幽灵", internalName: "天然紫幽灵", image: "running-ring-013.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然红胶花水晶", internalName: "3A天然红胶花水晶", image: "running-ring-014.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "7A天然冰种水草玛瑙", internalName: "7A天然冰种水草玛瑙", image: "running-ring-015.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然水草玛瑙", internalName: "5A天然水草玛瑙", image: "running-ring-016.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然黑发晶", internalName: "3A天然黑发晶", image: "running-ring-017.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "白色猫眼石", internalName: "白色猫眼石", image: "running-ring-018.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然绿幽灵水晶", internalName: "天然绿幽灵水晶", image: "running-ring-019.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "7A天然海蓝宝", internalName: "7A天然海蓝宝", image: "running-ring-020.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然萤石", internalName: "3A天然萤石", image: "running-ring-021.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然棉絮金发晶", internalName: "天然棉絮金发晶", image: "running-ring-022.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "优化蓝松石", internalName: "优化蓝松石", image: "running-ring-023.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "7A红玛瑙", internalName: "7A红玛瑙", image: "running-ring-024.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然青金石", internalName: "5A天然青金石", image: "running-ring-025.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然石榴石", internalName: "5A天然石榴石", image: "running-ring-026.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然黑色条纹玛瑙", internalName: "天然黑色条纹玛瑙", image: "running-ring-027.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然粉晶圆珠流苏跑环", internalName: "天然粉晶圆珠流苏跑环", image: "running-ring-028.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然草莓晶圆珠流苏跑环", internalName: "3A天然草莓晶圆珠流苏跑环", image: "running-ring-029.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "2A天然黄塔晶圆珠流苏跑环", internalName: "2A天然黄塔晶圆珠流苏跑环", image: "running-ring-030.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然黄胶花水晶圆珠流苏跑环", internalName: "天然黄胶花水晶圆珠流苏跑环", image: "running-ring-031.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然紫水晶圆珠流苏跑环", internalName: "3A天然紫水晶圆珠流苏跑环", image: "running-ring-032.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然白水晶圆珠流苏跑环", internalName: "5A天然白水晶圆珠流苏跑环", image: "running-ring-033.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然白水晶铜隔圈圆珠跑环", internalName: "5A天然白水晶铜隔圈圆珠跑环", image: "running-ring-034.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然粉晶铜隔圈圆珠跑环", internalName: "天然粉晶铜隔圈圆珠跑环", image: "running-ring-035.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然紫水晶铜隔圈圆珠跑环", internalName: "3A天然紫水晶铜隔圈圆珠跑环", image: "running-ring-036.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然草莓晶铜隔圈圆珠跑环", internalName: "5A天然草莓晶铜隔圈圆珠跑环", image: "running-ring-037.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "1A天然黄塔晶铜隔圈圆珠跑环", internalName: "1A天然黄塔晶铜隔圈圆珠跑环", image: "running-ring-038.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然红绿宝8颗圆珠跑环", internalName: "天然红绿宝8颗圆珠跑环", image: "running-ring-039.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然深粉澳宝8颗圆珠跑环", internalName: "天然深粉澳宝8颗圆珠跑环", image: "running-ring-040.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然天河石8颗圆珠跑环", internalName: "3A天然天河石8颗圆珠跑环", image: "running-ring-041.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然梦幻海蓝宝8颗圆珠跑环", internalName: "天然梦幻海蓝宝8颗圆珠跑环", image: "running-ring-042.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然黑金超七水晶8颗圆珠跑环", internalName: "天然黑金超七水晶8颗圆珠跑环", image: "running-ring-043.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然白月光8颗圆珠跑环", internalName: "3A天然白月光8颗圆珠跑环", image: "running-ring-044.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然彩萤石8颗圆珠跑环", internalName: "3A天然彩萤石8颗圆珠跑环", image: "running-ring-045.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "7A天然茶水晶8颗圆珠跑环", internalName: "7A天然茶水晶8颗圆珠跑环", image: "running-ring-046.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然黑发晶8颗圆珠跑环", internalName: "3A天然黑发晶8颗圆珠跑环", image: "running-ring-047.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然冰透金发晶8颗圆珠跑环", internalName: "天然冰透金发晶8颗圆珠跑环", image: "running-ring-048.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然摩根石8颗圆珠跑环", internalName: "5A天然摩根石8颗圆珠跑环", image: "running-ring-049.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然草莓晶8颗圆珠跑环", internalName: "5A天然草莓晶8颗圆珠跑环", image: "running-ring-050.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然红发晶8颗圆珠跑环", internalName: "天然红发晶8颗圆珠跑环", image: "running-ring-051.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然绿萤石8颗圆珠跑环", internalName: "天然绿萤石8颗圆珠跑环", image: "running-ring-052.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然红胶花水晶8颗圆珠跑环", internalName: "3A天然红胶花水晶8颗圆珠跑环", image: "running-ring-053.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然梦幻紫水晶8颗圆珠跑环", internalName: "5A天然梦幻紫水晶8颗圆珠跑环", image: "running-ring-054.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然青金石8颗圆珠跑环", internalName: "3A天然青金石8颗圆珠跑环", image: "running-ring-055.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然冰种粉水晶8颗圆珠跑环", internalName: "3A天然冰种粉水晶8颗圆珠跑环", image: "running-ring-056.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然葡萄石8颗圆珠跑环", internalName: "5A天然葡萄石8颗圆珠跑环", image: "running-ring-057.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然绿草莓晶8颗圆珠跑环", internalName: "天然绿草莓晶8颗圆珠跑环", image: "running-ring-058.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "3A天然白水晶8颗圆珠跑环", internalName: "3A天然白水晶8颗圆珠跑环", image: "running-ring-059.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "7A天然白水晶8颗圆珠跑环", internalName: "7A天然白水晶8颗圆珠跑环", image: "running-ring-060.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "5A天然金太阳石8颗圆珠跑环", internalName: "5A天然金太阳石8颗圆珠跑环", image: "running-ring-061.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 },
    { category: "Accessories", name: "天然冰种天河石8颗圆珠跑环", internalName: "天然冰种天河石8颗圆珠跑环", image: "running-ring-062.png", sizes: [8], price: 0, kind: "accessory", spacingMm: 3.2, visualWidthMm: 4.4, visualHeightMm: 18, hangOffsetMm: 0 }
  ];

  const jiuyaCatalog = window.MinestoneJiuyaCatalog || {};
  const accessoryCatalog = window.MinestoneAccessoryCatalog || {};
  const componentMap = window.MinestoneDIYComponentMap || {};
  const accessoryMapping = accessoryCatalog.mappingByImage || {};
  beadMasters.forEach((master) => {
    if (master.category === "Accessories" && accessoryMapping[master.image]) {
      Object.assign(master, accessoryMapping[master.image]);
    }
  });
  beadMasters.push(...(jiuyaCatalog.beads || []));
  beadMasters.push(...(accessoryCatalog.items || []));

  function componentBinding(master, size) {
    if (master.itemId?.startsWith("ACC-")) {
      return componentMap.components?.[master.itemId] || null;
    }
    if (master.itemId?.startsWith("RUNNING-RING-")) {
      const componentId = master.itemId.replace("RUNNING-RING-", "RING-");
      return componentMap.components?.[componentId] || null;
    }
    return componentMap.beads?.[`${master.image}|${size}`]
      || componentMap.beads?.[`${master.name}|${size}`]
      || null;
  }

  const catalog = beadMasters.flatMap((master) => (
    master.sizes.map((size) => ({
      ...master,
      size,
      masterName: master.name,
      component: componentBinding(master, size)
    }))
  ));
  const imageFillRatios = {
    "7a-clear-quartz.png": 0.659,
    "7a-sunstone.png": 0.673,
    "7a-tea-quartz.png": 0.736,
    "aquamarine.png": 0.748,
    "amazonite.png": 0.787,
    "amethyst.png": 0.785,
    "ametrine.png": 0.786,
    "black-tourmaline.png": 0.789,
    "blue-cherry-blossom-agate.png": 0.785,
    "blue-tiger-eye.png": 0.698,
    "color-rabbit-hair-quartz.png": 0.739,
    "fantasy-amethyst.png": 0.782,
    "fantasy-tiger-eye.png": 0.793,
    "golden-citrine.png": 0.752,
    "golden-obsidian.png": 0.79,
    "golden-silk-jade.png": 0.783,
    "green-aventurine.png": 0.789,
    "green-cherry-blossom-agate.png": 0.795,
    "green-phantom-quartz.png": 0.782,
    "hetian-jade.png": 0.686,
    "honey-yellow-jade.png": 0.742,
    "indian-blue-moonstone.png": 0.748,
    "indian-moss-agate.png": 0.793,
    "jiuzi-lihuo.png": 0.659,
    "kyanite.png": 0.757,
    "morganite.png": 0.78,
    "mutton-fat-jade.png": 0.714,
    "natural-violet-stone.png": 0.784,
    "old-mine-strawberry-quartz.png": 0.793,
    "opaque-rose-quartz.png": 0.753,
    "prehnite.png": 0.813,
    "purple-lepidolite.png": 0.79,
    "purple-phantom-quartz.png": 0.779,
    "rainbow-eye-obsidian.png": 0.792,
    "rainbow-multistone.png": 0.691,
    "red-agate.png": 0.788,
    "red-crystal-sand.png": 0.717,
    "red-garden-quartz.png": 0.744,
    "rhodonite-rose-stone.png": 0.795,
    "selenite-gypsum.png": 0.784,
    "silver-obsidian.png": 0.749,
    "snowflake-phantom.png": 0.722,
    "snowflake-stone.png": 0.76,
    "super-seven.png": 0.726,
    "white-turquoise.png": 0.779,
    "xiuyan-jade.png": 0.642,
    "yellow-garden-quartz.png": 0.79,
    "yellow-tiger-eye.png": 0.785
  };
  Object.assign(imageFillRatios, jiuyaCatalog.imageFillRatios || {});
  const imageRoundnessFix = {
    "7a-clear-quartz.png": 1.036,
    "7a-sunstone.png": 1.058,
    "7a-tea-quartz.png": 1.048,
    "aquamarine.png": 1.033,
    "amazonite.png": 1.03,
    "amethyst.png": 1.021,
    "ametrine.png": 1.028,
    "black-tourmaline.png": 1.023,
    "blue-cherry-blossom-agate.png": 1.025,
    "blue-tiger-eye.png": 1.021,
    "color-rabbit-hair-quartz.png": 1.008,
    "fantasy-amethyst.png": 1.026,
    "fantasy-tiger-eye.png": 1.03,
    "golden-citrine.png": 1.043,
    "golden-obsidian.png": 1.02,
    "golden-silk-jade.png": 1.038,
    "green-aventurine.png": 1.027,
    "green-cherry-blossom-agate.png": 1.035,
    "green-phantom-quartz.png": 1.022,
    "hetian-jade.png": 1.045,
    "honey-yellow-jade.png": 1.046,
    "indian-blue-moonstone.png": 1.039,
    "indian-moss-agate.png": 1.043,
    "jiuzi-lihuo.png": 1.018,
    "kyanite.png": 1.024,
    "morganite.png": 1.022,
    "mutton-fat-jade.png": 1.024,
    "natural-violet-stone.png": 1.024,
    "old-mine-strawberry-quartz.png": 1.023,
    "opaque-rose-quartz.png": 1.036,
    "prehnite.png": 1.011,
    "purple-lepidolite.png": 1.011,
    "purple-phantom-quartz.png": 1.03,
    "rainbow-eye-obsidian.png": 1.021,
    "rainbow-multistone.png": 1.04,
    "red-agate.png": 1.032,
    "red-crystal-sand.png": 1.05,
    "red-garden-quartz.png": 1.026,
    "rhodonite-rose-stone.png": 1.036,
    "selenite-gypsum.png": 1.026,
    "silver-obsidian.png": 1.03,
    "snowflake-phantom.png": 1.068,
    "snowflake-stone.png": 1.027,
    "super-seven.png": 1.032,
    "white-turquoise.png": 1.023,
    "xiuyan-jade.png": 1.044,
    "yellow-garden-quartz.png": 1.03,
    "yellow-tiger-eye.png": 1.019
  };
  Object.assign(imageRoundnessFix, jiuyaCatalog.imageRoundnessFix || {});
  const sizes = [...new Set(catalog.map((item) => item.size))].sort((a, b) => a - b);
  const accessoryStyles = accessoryCatalog.styles || [];
  const minCm = 13;
  const maxCm = 28;
  const targetPxPerMm = 8.2;

  function uuid() {
    if (crypto.randomUUID) return crypto.randomUUID();
    return `ms-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  function money() {
    return priceNote();
  }

  function priceNote() {
    return "Price shown at checkout";
  }

  function cm(value) {
    return Number(value).toFixed(1).replace(/\.0$/, "");
  }

  function priceFor(item) {
    return (item.component?.unitPriceCents || 0) / 100;
  }

  function formatMoney(value, currencyCode, currencyCodeEnabled, fallbackSymbol) {
    const amount = Number(value || 0);
    if (currencyCode && window.Intl?.NumberFormat) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: currencyCode,
          currencyDisplay: currencyCodeEnabled ? "code" : "symbol"
        }).format(amount);
      } catch (error) {
        // Fall through to the simple formatter below.
      }
    }
    return `${fallbackSymbol || "$"}${amount.toFixed(2)}${currencyCodeEnabled && currencyCode ? ` ${currencyCode}` : ""}`;
  }

  roots.forEach((root) => {
    window.MinestoneDIYBindingAudit = {
      total: catalog.length,
      missing: catalog.filter((item) => !item.component).map((item) => `${item.image}|${item.size}`)
    };
    root.dataset.componentBindingTotal = String(catalog.length);
    root.dataset.componentBindingMissing = String(catalog.filter((item) => !item.component).length);
    root.dataset.componentMapSha = componentMap.sourceSha256 || "";
    const assetBase = root.dataset.assetBase;
    const variantId = root.dataset.variantId;
    const currencyCode = root.dataset.currencyCode || "";
    const currencySymbol = root.dataset.currencySymbol || "$";
    const currencyCodeEnabled = root.dataset.currencyCodeEnabled === "true";

    function track(eventName, parameters = {}) {
      return window.TCEDIYAnalytics?.emit?.(eventName, parameters) || false;
    }

    function trackStart(startAction) {
      return window.TCEDIYAnalytics?.emitBuilderStart?.(startAction) || false;
    }

    function designCounts(items = selected) {
      const accessoryCount = items.filter((item) => isAccessory(item)).length;
      return {
        design_item_count: items.length,
        bead_count: items.length - accessoryCount,
        accessory_count: accessoryCount
      };
    }
    const selected = [];
    let activeCategory = "Accessories";
    let activeSize = 8;
    let lastBeadSize = activeSize;
    let activeAccessoryStyle = null;
    let activeUid = null;
    let toastTimer = null;
    let dragState = null;
    let addInFlight = false;
    let suppressClickUid = null;
    let lastBeadClick = { uid: null, time: 0 };

    const els = {
      categoryList: root.querySelector("[data-category-list]"),
      sizeList: root.querySelector("[data-size-list]"),
      secondaryTitle: root.querySelector("[data-secondary-title]"),
      secondaryHint: root.querySelector("[data-secondary-hint]"),
      catalog: root.querySelector("[data-catalog]"),
      ringWrap: root.querySelector("[data-ring-wrap]"),
      ring: root.querySelector("[data-ring]"),
      empty: root.querySelector("[data-empty]"),
      beadCount: root.querySelector("[data-bead-count]"),
      beadLength: root.querySelector("[data-bead-length]"),
      wristLength: root.querySelector("[data-wrist-length]"),
      beadValue: root.querySelector("[data-bead-value]"),
      add: root.querySelector("[data-add-design]"),
      clear: root.querySelector("[data-clear-design]"),
      toast: root.querySelector("[data-toast]")
    };

    function imageFor(item) {
      const accessoryVersion = item.image.startsWith("diy-accessory-") ? "?v=final-151-transparent-20260720" : "";
      return `${assetBase}${item.image}${accessoryVersion}`;
    }

    function isAccessory(item) {
      return item.kind === "accessory";
    }

    function isRunningRing(item) {
      return item.itemId?.startsWith("RUNNING-RING-");
    }

    function usesAccessoryPlacement(item) {
      return isAccessory(item) || item.itemId?.startsWith("ACC-");
    }

    function lineSizeMm(item) {
      return item.spacingMm || item.size;
    }

    function accessoryArcSidesMm(item, lineMm) {
      const widthMm = item.visualWidthMm || item.size;
      const heightMm = item.visualHeightMm || item.size;
      const radiusMm = lineMm / (Math.PI * 2);
      // The accepted 62-image alpha template has slightly asymmetric inner edges.
      const beforeMm = radiusMm * Math.atan(
        (widthMm * 0.3425) / Math.max(0.1, radiusMm - heightMm * 0.3906432749)
      );
      const afterMm = radiusMm * Math.atan(
        (widthMm * 0.3923444976) / Math.max(0.1, radiusMm - heightMm * 0.3964912281)
      );
      return { beforeMm, afterMm };
    }

    function layoutGeometryAtLine(items, lineMm) {
      const accessorySides = items.map((item) => (
        isAccessory(item) ? accessoryArcSidesMm(item, lineMm) : null
      ));
      const pairDistancesMm = items.map((item, index) => {
        const nextIndex = (index + 1) % items.length;
        const next = items[nextIndex];
        if (!isAccessory(item) && !isAccessory(next)) {
          return (lineSizeMm(item) + lineSizeMm(next)) / 2 + 0.08;
        }
        const afterMm = accessorySides[index]?.afterMm || lineSizeMm(item) * 0.475;
        const beforeMm = accessorySides[nextIndex]?.beforeMm || lineSizeMm(next) * 0.475;
        const guardMm = isAccessory(item) && isAccessory(next) ? 0.005 : 0.05;
        // A small visual bite removes the dark seam between opaque silhouettes.
        const contactInsetMm = isAccessory(item) && isAccessory(next) ? 0.4 : 0.22;
        return Math.max(0.1, afterMm + beforeMm + guardMm - contactInsetMm + 0.08);
      });
      const centersMm = [];
      let centerMm = items.length ? lineSizeMm(items[0]) / 2 : 0;
      items.forEach((item, index) => {
        centersMm.push(centerMm);
        centerMm += pairDistancesMm[index];
      });
      const footprintsMm = items.map((item, index) => (
        accessorySides[index]
          ? accessorySides[index].beforeMm + accessorySides[index].afterMm + 0.05
          : lineSizeMm(item)
      ));
      return { centersMm, footprintsMm, pairDistancesMm };
    }

    function layoutFootprintMetrics(items = selected) {
      let lineMm = Math.max(minCm * 10, items.reduce((sum, item) => sum + lineSizeMm(item), 0));
      let footprintsMm = items.map((item) => lineSizeMm(item));
      let centersMm = items.map((item, index) => (
        items.slice(0, index).reduce((sum, other) => sum + lineSizeMm(other), 0) + lineSizeMm(item) / 2
      ));

      for (let pass = 0; pass < 6; pass += 1) {
        const geometry = layoutGeometryAtLine(items, lineMm);
        footprintsMm = geometry.footprintsMm;
        centersMm = geometry.centersMm;
        const nextLineMm = Math.max(minCm * 10, geometry.pairDistancesMm.reduce((sum, distance) => sum + distance, 0));
        if (Math.abs(nextLineMm - lineMm) < 0.001) {
          lineMm = nextLineMm;
          const stableGeometry = layoutGeometryAtLine(items, lineMm);
          footprintsMm = stableGeometry.footprintsMm;
          centersMm = stableGeometry.centersMm;
          break;
        }
        lineMm = nextLineMm;
      }

      return { lineMm, footprintsMm, centersMm };
    }

    function categories() {
      return [...new Set(beadMasters.map((item) => item.category))];
    }

    function categoryHasSize(category, size) {
      return catalog.some((item) => item.category === category && item.size === size);
    }

    function categoryHasBeads(category) {
      return catalog.some((item) => item.category === category);
    }

    function firstSizeForCategory(category) {
      return sizes.find((size) => categoryHasSize(category, size)) || null;
    }

    function ensureAvailableSize() {
      if (activeCategory === "Accessories") return;
      if (categoryHasSize(activeCategory, activeSize)) return;
      const fallback = firstSizeForCategory(activeCategory);
      if (fallback) activeSize = fallback;
    }

    function filteredCatalog() {
      return catalog
        .filter((item) => {
          if (activeCategory === "Accessories") {
            return item.category === activeCategory
              && (!activeAccessoryStyle || item.styleCategory === activeAccessoryStyle);
          }
          return item.category === activeCategory && item.size === activeSize;
        })
        .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
    }

    function beadLength(items = selected) {
      return items.reduce((sum, item) => sum + (isAccessory(item) ? 0 : item.size), 0) / 10;
    }

    function braceletLength(items = selected) {
      return Math.max(minCm, Math.min(maxCm, beadLength(items)));
    }

    function visualLineLengthMm(items = selected) {
      return layoutFootprintMetrics(items).lineMm;
    }

    function selectedBeadValue() {
      return selected.reduce((sum, item) => sum + priceFor(item), 0);
    }

    function isDesktopPreview() {
      return window.matchMedia?.("(min-width: 901px)").matches;
    }

    function shouldShowAddToast() {
      return window.matchMedia?.("(min-width: 901px)").matches;
    }

    function toast(message) {
      clearTimeout(toastTimer);
      els.toast.textContent = message;
      els.toast.classList.add("is-visible");
      toastTimer = setTimeout(() => els.toast.classList.remove("is-visible"), 1600);
    }

    function previewMetrics(items = selected) {
      const layout = layoutFootprintMetrics(items);
      const lineMm = layout.lineMm;
      const maxVisualBeadMm = Math.max(8, ...items.map((item) => (
        isAccessory(item)
          ? (item.visualHeightMm || item.size)
          : (item.size / (imageFillRatios[item.image] || 0.78)) * (imageRoundnessFix[item.image] || 1)
      )));
      const lineDiameterMm = lineMm / Math.PI;
      const outerDiameterMm = lineDiameterMm + maxVisualBeadMm;
      const wrapWidth = els.ringWrap?.clientWidth || 520;
      const fitPxPerMm = Math.max(2.2, (wrapWidth - 36) / outerDiameterMm);
      const pxPerMm = Math.min(targetPxPerMm, fitPxPerMm);

      return {
        lineMm,
        lineDiameterPx: lineDiameterMm * pxPerMm,
        outerDiameterPx: outerDiameterMm * pxPerMm,
        radiusPx: (lineDiameterMm * pxPerMm) / 2,
        pxPerMm,
        layoutFootprintsMm: layout.footprintsMm,
        layoutCentersMm: layout.centersMm
      };
    }

    function renderCategories() {
      els.categoryList.innerHTML = "";
      categories().forEach((category) => {
        const isAvailable = categoryHasBeads(category);
        const button = document.createElement("button");
        button.type = "button";
        button.className = [
          "minestone-diy__category",
          category === activeCategory ? "is-active" : "",
          isAvailable ? "" : "is-disabled"
        ].filter(Boolean).join(" ");
        button.textContent = category;
        button.disabled = !isAvailable;
        button.setAttribute("aria-disabled", String(!isAvailable));
        if (!isAvailable) {
          button.title = "No beads available";
          button.setAttribute("aria-label", `${category}. No beads available`);
        }
        button.addEventListener("click", () => {
          if (!isAvailable) {
            toast("No beads available.");
            return;
          }
          if (category === "Accessories" && activeCategory !== "Accessories") {
            lastBeadSize = activeSize;
          }
          if (category !== "Accessories" && activeCategory === "Accessories") {
            activeAccessoryStyle = null;
            activeSize = lastBeadSize;
          }
          activeCategory = category;
          ensureAvailableSize();
          render();
        });
        els.categoryList.appendChild(button);
      });
    }

    function renderSizes() {
      els.sizeList.innerHTML = "";
      const showingAccessories = activeCategory === "Accessories";
      root.classList.toggle("is-accessories-active", showingAccessories);
      els.secondaryTitle.textContent = showingAccessories ? "Accessory style" : "Bead size";
      els.secondaryHint.textContent = showingAccessories ? "Choose by accessory type" : "2-18 mm";
      if (showingAccessories) {
        accessoryStyles.forEach((style) => {
          const count = catalog.filter((item) => (
            item.category === "Accessories" && item.styleCategory === style
          )).length;
          if (!count) return;
          const button = document.createElement("button");
          button.type = "button";
          button.className = [
            "minestone-diy__pill",
            style === activeAccessoryStyle ? "is-active" : ""
          ].filter(Boolean).join(" ");
          const label = document.createElement("span");
          label.className = "minestone-diy__pill-text";
          style.split(" ").forEach((word, index) => {
            if (index > 0 && word !== "&") label.appendChild(document.createElement("br"));
            label.append(document.createTextNode(index > 0 && word === "&" ? ` ${word}` : word));
          });
          button.appendChild(label);
          button.setAttribute("aria-pressed", String(style === activeAccessoryStyle));
          button.addEventListener("click", () => {
            activeAccessoryStyle = style;
            render();
          });
          els.sizeList.appendChild(button);
        });
        return;
      }
      sizes.forEach((size) => {
        const isAvailable = categoryHasSize(activeCategory, size);
        const button = document.createElement("button");
        button.type = "button";
        button.className = [
          "minestone-diy__pill",
          size === activeSize ? "is-active" : "",
          isAvailable ? "" : "is-disabled"
        ].filter(Boolean).join(" ");
        button.textContent = `${size} mm`;
        button.disabled = !isAvailable;
        button.setAttribute("aria-disabled", String(!isAvailable));
        if (!isAvailable) {
          button.title = "No beads in this size";
          button.setAttribute("aria-label", `${size} mm. No beads in this size`);
        }
        button.addEventListener("click", () => {
          if (!isAvailable) {
            toast("No beads in this size.");
            return;
          }
          activeSize = size;
          lastBeadSize = size;
          render();
          trackStart("size_select");
          track("diy_size_select", {
            bead_family: activeCategory || "unknown",
            bead_size_mm: activeSize
          });
        });
        els.sizeList.appendChild(button);
      });
    }

    function renderCatalog() {
      const items = filteredCatalog();
      els.catalog.innerHTML = "";
      if (!items.length) {
        els.catalog.innerHTML = `<p class="minestone-diy__empty">No items available yet.</p>`;
        return;
      }
      items.forEach((item) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "minestone-diy__card";
        button.dataset.componentId = item.component?.componentId || "";
        button.dataset.variantId = item.component?.variantId || "";
        button.style.setProperty("--bead-scale-x", imageRoundnessFix[item.image] || 1);
        if (isAccessory(item)) button.classList.add("minestone-diy__card--accessory");
        const meta = formatMoney(priceFor(item), currencyCode, currencyCodeEnabled, currencySymbol);
        button.innerHTML = `<img alt="${item.name}" src="${imageFor(item)}"><span class="minestone-diy__card-name">${item.name}</span><span class="minestone-diy__card-meta">${meta}</span>`;
        button.addEventListener("click", () => addBead(item));
        els.catalog.appendChild(button);
      });
    }

    function addBead(item) {
      if (beadLength([...selected, item]) > maxCm) {
        toast(`This crystal would exceed ${maxCm} cm.`);
        return;
      }
      selected.push({ ...item, uid: uuid() });
      activeUid = null;
      renderRing();
      renderSummary();
      const counts = designCounts();
      if (isAccessory(item)) {
        trackStart("accessory_select");
        track("diy_accessory_select", {
          accessory_type: item.styleCategory || item.kind || "unknown",
          accessory_id: item.itemId || item.component?.componentId || "unknown",
          design_item_count: counts.design_item_count,
          accessory_count: counts.accessory_count
        });
      } else {
        trackStart("bead_select");
        track("diy_bead_select", {
          bead_family: item.category || "unknown",
          bead_size_mm: item.size || "unknown",
          design_item_count: counts.design_item_count,
          bead_count: counts.bead_count
        });
      }
      if (shouldShowAddToast()) {
        toast(`Added ${item.name}`);
      }
    }

    function removeBead(uid) {
      const index = selected.findIndex((item) => item.uid === uid);
      if (index >= 0) {
        const [removed] = selected.splice(index, 1);
        activeUid = null;
        renderRing();
        renderSummary();
        toast(`Removed ${removed.name}`);
      }
    }

    function reorderBead(uid, angle) {
      const index = selected.findIndex((item) => item.uid === uid);
      if (index < 0) return;

      const [item] = selected.splice(index, 1);
      const accessoryLayout = isAccessory(item) ? layoutFootprintMetrics([...selected, item]) : null;
      const lineMm = accessoryLayout
        ? accessoryLayout.lineMm
        : braceletLength([...selected, item]) * 10;
      const normalized = ((angle + Math.PI / 2) % (Math.PI * 2) + Math.PI * 2) % (Math.PI * 2);
      const targetMm = (normalized / (Math.PI * 2)) * lineMm;

      let insertIndex = 0;
      if (accessoryLayout && selected.length) {
        const selectedGeometry = layoutGeometryAtLine(selected, lineMm);
        selectedGeometry.centersMm.forEach((centerMm, otherIndex) => {
          if (targetMm > centerMm) insertIndex = otherIndex + 1;
        });
      } else {
        let cursorMm = 0;
        selected.forEach((other, otherIndex) => {
          const midpointMm = cursorMm + lineSizeMm(other) / 2;
          if (targetMm > midpointMm) insertIndex = otherIndex + 1;
          cursorMm += lineSizeMm(other);
        });
      }
      selected.splice(insertIndex, 0, item);
      activeUid = uid;
    }

    function eventPoint(event) {
      const touch = event.changedTouches?.[0] || event.touches?.[0];
      if (touch) return { x: touch.clientX, y: touch.clientY };
      if (typeof event.clientX === "number" && typeof event.clientY === "number") {
        return { x: event.clientX, y: event.clientY };
      }
      return null;
    }

    function closestAccessoryTarget(point, fallbackItem, fallbackBead) {
      if (!usesAccessoryPlacement(fallbackItem)) return { item: fallbackItem, bead: fallbackBead };

      let closest = { item: fallbackItem, bead: fallbackBead, distance: Infinity };
      els.ring.querySelectorAll(".minestone-diy__bead--accessory").forEach((candidate) => {
        const rect = candidate.getBoundingClientRect();
        const distance = Math.hypot(
          point.x - (rect.left + rect.width / 2),
          point.y - (rect.top + rect.height / 2)
        );
        const candidateItem = selected.find((entry) => entry.uid === candidate.dataset.uid);
        if (candidateItem && distance < closest.distance) {
          closest = { item: candidateItem, bead: candidate, distance };
        }
      });
      return { item: closest.item, bead: closest.bead };
    }

    function activateBead(uid) {
      const item = selected.find((entry) => entry.uid === uid);
      if (!item) return;

      const now = Date.now();
      const isDoubleClick = lastBeadClick.uid === uid && now - lastBeadClick.time <= 360;
      lastBeadClick = { uid, time: now };

      if (isDoubleClick) {
        lastBeadClick = { uid: null, time: 0 };
        removeBead(uid);
      } else {
        activeUid = uid;
        renderRing();
      }
    }

    function suppressNativeClick(uid) {
      suppressClickUid = uid;
      setTimeout(() => {
        if (suppressClickUid === uid) suppressClickUid = null;
      }, 500);
    }

    function beginBeadDrag(event, sourceItem, sourceBead) {
      if (dragState) return;
      if (event.button !== undefined && event.button !== 0) return;
      const point = eventPoint(event);
      if (!point) return;
      const target = closestAccessoryTarget(point, sourceItem, sourceBead);
      const item = target.item;
      const bead = target.bead;

      const metrics = previewMetrics();
      const ringRect = els.ring.getBoundingClientRect();
      const beadSize = parseFloat(bead.style.getPropertyValue("--size")) || 0;
      const inputMode = event.type.startsWith("pointer")
        ? "pointer"
        : event.type.startsWith("touch") ? "touch" : "mouse";
      dragState = {
        uid: item.uid,
        bead,
        captureBead: sourceBead,
        sourceUid: sourceItem.uid,
        isAccessory: usesAccessoryPlacement(item),
        inputMode,
        pointerId: inputMode === "pointer" ? event.pointerId : null,
        startX: point.x,
        startY: point.y,
        centerX: ringRect.left + ringRect.width / 2,
        centerY: ringRect.top + ringRect.height / 2,
        deleteDistancePx: metrics.radiusPx + beadSize * 0.9 + 24,
        activationDistancePx: usesAccessoryPlacement(item) ? 3 : 6,
        moved: false,
        removing: false,
        angle: 0
      };
      activeUid = item.uid;
      bead.classList.add("is-dragging");
      if (inputMode === "pointer") {
        sourceBead.setPointerCapture?.(event.pointerId);
        document.addEventListener("pointermove", updateBeadDrag);
        document.addEventListener("pointerup", endBeadDrag);
        document.addEventListener("pointercancel", endBeadDrag);
      } else if (inputMode === "touch") {
        document.addEventListener("touchmove", updateBeadDrag, { passive: false });
        document.addEventListener("touchend", endBeadDrag);
        document.addEventListener("touchcancel", endBeadDrag);
      } else {
        document.addEventListener("mousemove", updateBeadDrag);
        document.addEventListener("mouseup", endBeadDrag);
      }
    }

    function updateBeadDrag(event) {
      if (!dragState) return;
      if (
        dragState.inputMode === "pointer"
        && event.pointerId !== dragState.pointerId
      ) return;
      const point = eventPoint(event);
      if (!point) return;

      const moveX = point.x - dragState.startX;
      const moveY = point.y - dragState.startY;
      if (!dragState.moved && Math.hypot(moveX, moveY) < dragState.activationDistancePx) return;

      dragState.moved = true;
      if (event.cancelable) event.preventDefault();

      const x = point.x - dragState.centerX;
      const y = point.y - dragState.centerY;
      const distance = Math.hypot(x, y);
      dragState.angle = Math.atan2(y, x);
      dragState.removing = distance > dragState.deleteDistancePx;
      dragState.bead.style.setProperty("--x", `${x}px`);
      dragState.bead.style.setProperty("--y", `${y}px`);
      if (dragState.isAccessory) {
        dragState.bead.style.setProperty("--rotate", `${dragState.angle * 180 / Math.PI + 90}deg`);
      }
      dragState.bead.classList.toggle("is-removing", dragState.removing);
    }

    function endBeadDrag(event) {
      if (!dragState) return;
      if (
        dragState.inputMode === "pointer"
        && event.pointerId !== dragState.pointerId
      ) return;

      const state = dragState;
      dragState = null;
      if (state.pointerId !== null && state.captureBead.hasPointerCapture?.(state.pointerId)) {
        state.captureBead.releasePointerCapture(state.pointerId);
      }
      state.bead.classList.remove("is-dragging", "is-removing");
      if (state.inputMode === "pointer") {
        document.removeEventListener("pointermove", updateBeadDrag);
        document.removeEventListener("pointerup", endBeadDrag);
        document.removeEventListener("pointercancel", endBeadDrag);
      } else if (state.inputMode === "touch") {
        document.removeEventListener("touchmove", updateBeadDrag);
        document.removeEventListener("touchend", endBeadDrag);
        document.removeEventListener("touchcancel", endBeadDrag);
      } else {
        document.removeEventListener("mousemove", updateBeadDrag);
        document.removeEventListener("mouseup", endBeadDrag);
      }

      suppressNativeClick(state.sourceUid);
      if (!state.moved) {
        activateBead(state.uid);
        return;
      }

      event.preventDefault();
      if (state.removing) {
        removeBead(state.uid);
      } else {
        reorderBead(state.uid, state.angle);
        renderRing();
        renderSummary();
        trackStart("design_reorder");
        track("diy_design_reorder", designCounts());
      }
    }

    function renderRing() {
      els.ring.querySelectorAll(".minestone-diy__bead").forEach((node) => node.remove());
      els.empty.hidden = selected.length > 0;

      const metrics = previewMetrics();
      els.ring.style.setProperty("--ring-diameter", `${metrics.lineDiameterPx}px`);
      els.ring.style.setProperty("--preview-size", `${metrics.outerDiameterPx + 36}px`);
      if (!selected.length) return;

      selected.forEach((item, itemIndex) => {
        const centerMm = metrics.layoutCentersMm[itemIndex];
        const angle = -Math.PI / 2 + (Math.PI * 2 * centerMm) / metrics.lineMm;
        const sizePx = item.size * metrics.pxPerMm;
        const isAccessoryItem = isAccessory(item);
        const usesAccessoryPlacementItem = usesAccessoryPlacement(item);
        const assetBoxPx = isAccessoryItem ? sizePx : sizePx / (imageFillRatios[item.image] || 0.78);
        const assetWidthPx = isAccessoryItem
          ? (item.visualWidthMm || item.size) * metrics.pxPerMm
          : assetBoxPx;
        const assetHeightPx = isAccessoryItem
          ? (item.visualHeightMm || item.size) * metrics.pxPerMm
          : assetBoxPx;
        const hangOffsetPx = isAccessoryItem ? (item.hangOffsetMm || 0) * metrics.pxPerMm : 0;
        const bead = document.createElement("button");
        bead.type = "button";
        bead.className = [
          "minestone-diy__bead",
          usesAccessoryPlacementItem ? "minestone-diy__bead--accessory" : "",
          activeUid === item.uid ? "is-active" : ""
        ].filter(Boolean).join(" ");
        bead.style.setProperty("--size", `${Math.max(assetWidthPx, assetHeightPx)}px`);
        bead.style.setProperty("--width", `${assetWidthPx}px`);
        bead.style.setProperty("--height", `${assetHeightPx}px`);
        bead.style.setProperty("--bead-z", String(Math.max(1, Math.round(10000 - Math.max(assetWidthPx, assetHeightPx)))));
        bead.style.setProperty("--x", `${Math.cos(angle) * (metrics.radiusPx + hangOffsetPx)}px`);
        bead.style.setProperty("--y", `${Math.sin(angle) * (metrics.radiusPx + hangOffsetPx)}px`);
        bead.style.setProperty("--rotate", `${angle * 180 / Math.PI + 90}deg`);
        bead.style.setProperty("--bead-scale-x", imageRoundnessFix[item.image] || 1);
        bead.dataset.uid = item.uid;
        bead.title = `${item.name} ${item.size} mm`;
        bead.innerHTML = `<img alt="" src="${imageFor(item)}">`;
        if (window.PointerEvent) {
          bead.addEventListener("pointerdown", (event) => beginBeadDrag(event, item, bead));
        } else {
          bead.addEventListener("mousedown", (event) => beginBeadDrag(event, item, bead));
          bead.addEventListener("touchstart", (event) => beginBeadDrag(event, item, bead), { passive: true });
        }
        bead.addEventListener("click", () => {
          if (suppressClickUid === item.uid) {
            suppressClickUid = null;
            return;
          }

          activateBead(item.uid);
        });
        els.ring.appendChild(bead);
      });

      els.add.disabled = selected.some((item) => !item.component) || beadLength() < minCm;
    }

    function renderSummary() {
      const length = beadLength();
      els.beadCount.textContent = selected.length;
      els.beadLength.textContent = `${cm(length)} cm`;
      els.wristLength.textContent = `${cm(braceletLength())} cm`;
      els.beadValue.textContent = formatMoney(selectedBeadValue(), currencyCode, currencyCodeEnabled, currencySymbol);
      els.add.disabled = selected.some((item) => !item.component) || length < minCm || length > maxCm;
    }

    function designSummary() {
      return selected.map((item, index) => `${index + 1}. ${item.name} ${item.size} mm`).join(" | ");
    }

    function snapshotValue(value) {
      return String(value ?? "").replace(/[~|]/g, " ").trim();
    }

    function designPreviewSnapshot() {
      const metrics = previewMetrics();
      const previewSizePx = metrics.outerDiameterPx + 36;
      const ringRatio = metrics.lineDiameterPx / previewSizePx;
      const beads = [...els.ring.querySelectorAll(".minestone-diy__bead")];
      const beadRows = selected.map((item, index) => {
        const bead = beads[index];
        const x = parseFloat(bead?.style.getPropertyValue("--x")) || 0;
        const y = parseFloat(bead?.style.getPropertyValue("--y")) || 0;
        const size = parseFloat(bead?.style.getPropertyValue("--size")) || 0;
        const rotate = bead?.style.getPropertyValue("--rotate").trim() || "0deg";
        const scaleX = bead?.style.getPropertyValue("--bead-scale-x").trim() || "1";

        return [
          index + 1,
          snapshotValue(item.name),
          item.size,
          snapshotValue(item.image),
          (x / previewSizePx).toFixed(5),
          (y / previewSizePx).toFixed(5),
          (size / previewSizePx).toFixed(5),
          snapshotValue(rotate.replace("deg", "")),
          snapshotValue(scaleX)
        ].join("~");
      });

      return [
        ["v1", previewSizePx.toFixed(2), ringRatio.toFixed(5)].join("~"),
        ...beadRows
      ].join(" || ");
    }

    async function addToCart() {
      if (addInFlight) return;
      const length = beadLength();
      if (!selected.length || selected.some((item) => !item.component)) {
        toast("This design is not ready to add to cart yet.");
        return;
      }
      if (length < minCm) {
        toast(`Add ${(minCm - length).toFixed(1)} cm more crystals.`);
        return;
      }
      const submitCounts = designCounts();
      track("diy_cart_submit_click", {
        ...submitCounts,
        estimated_design_value: Number(selectedBeadValue().toFixed(2)),
        currency: currencyCode || "unknown"
      });
      addInFlight = true;
      els.add.disabled = true;
      const designGroupId = uuid();
      const grouped = new Map();
      selected.forEach((item, index) => {
        const key = String(item.component.variantId);
        const group = grouped.get(key) || { item, positions: [] };
        group.positions.push(index + 1);
        grouped.set(key, group);
      });
      const designTotal = formatMoney(selectedBeadValue(), currencyCode, currencyCodeEnabled, currencySymbol);
      const groupedChunks = [];
      grouped.forEach((group) => {
        let chunk = [];
        group.positions.forEach((position) => {
          const candidate = [...chunk, position].join(",");
          if (candidate.length > 180 && chunk.length) {
            groupedChunks.push({ item: group.item, positions: chunk });
            chunk = [position];
          } else {
            chunk.push(position);
          }
        });
        if (chunk.length) groupedChunks.push({ item: group.item, positions: chunk });
      });
      const items = groupedChunks.map((group, index) => ({
        id: Number(group.item.component.variantId),
        quantity: group.positions.length,
        properties: {
          "Design type": "DIY crystal bracelet",
          "_DIY_design_group_id": designGroupId,
          "_DIY_component_id": group.item.component.componentId,
          "_DIY_sequence_positions": group.positions.join(","),
          "_DIY_group_component_count": String(selected.length),
          ...(index === 0 ? {
            "Design type": "DIY crystal bracelet",
            "Bead count": String(selected.length),
            "Component count": String(selected.length),
            "Bead length": `${cm(length)} cm`,
            "Wrist length": `${cm(braceletLength())} cm`,
            "Estimated design total": designTotal,
            "Bead sequence": designSummary(),
            "_DIY preview snapshot": designPreviewSnapshot()
          } : {})
        }
      }));
      const payload = { items };
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify(payload)
        });
        if (!response.ok) {
          const error = new Error("Cart request failed");
          error.status = response.status;
          throw error;
        }
        const result = await response.json();
        let redirectStarted = false;
        const redirectToCart = () => {
          if (redirectStarted) return;
          redirectStarted = true;
          window.location.href = "/cart";
        };
        const tracked = track("diy_cart_submit_result", {
          ...submitCounts,
          result: "success",
          error_type: "",
          cart_line_count_delta: Array.isArray(result.items) ? result.items.length : items.length,
          event_callback: redirectToCart,
          event_timeout: 500
        });
        if (!tracked) redirectToCart();
        else window.setTimeout(redirectToCart, 650);
      } catch (error) {
        track("diy_cart_submit_result", {
          ...submitCounts,
          result: "error",
          error_type: error.status ? `http_${error.status}` : "network_or_parse",
          cart_line_count_delta: 0
        });
        addInFlight = false;
        els.add.disabled = false;
        toast("Could not add to cart yet. Please try again.");
      }
    }

    function clearDesign() {
      const countsBeforeClear = designCounts();
      track("diy_design_clear", {
        design_item_count_before_clear: countsBeforeClear.design_item_count,
        bead_count_before_clear: countsBeforeClear.bead_count,
        accessory_count_before_clear: countsBeforeClear.accessory_count
      });
      selected.splice(0, selected.length);
      activeUid = null;
      renderRing();
      renderSummary();
      toast("Design cleared.");
    }

    function render() {
      ensureAvailableSize();
      renderCategories();
      renderSizes();
      renderCatalog();
      renderRing();
      renderSummary();
    }

    els.add.addEventListener("click", addToCart);
    els.clear.addEventListener("click", clearDesign);
    window.addEventListener("resize", () => renderRing());
    render();
  });
})();
